// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/store_shipping/v1/store_shipping.proto (package fingertip.creator.store_shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, StringValue } from "@bufbuild/protobuf";
import { StoreShippingConfig } from "../../../common/type/v1/store_shipping_config_pb.js";
import { StoreShippingRateType } from "../../../common/enum/v1/store_shipping_rate_type_pb.js";
import { StoreShippingRate } from "../../../common/type/v1/store_shipping_rate_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";

/**
 * Shipping Config Messages
 *
 * @generated from message fingertip.creator.store_shipping.v1.UpsertShippingConfigRequest
 */
export const UpsertShippingConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.UpsertShippingConfigRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "accepted_countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.UpsertShippingConfigResponse
 */
export const UpsertShippingConfigResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.UpsertShippingConfigResponse",
  () => [
    { no: 1, name: "config", kind: "message", T: StoreShippingConfig },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingConfigRequest
 */
export const GetShippingConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingConfigRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingConfigResponse
 */
export const GetShippingConfigResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingConfigResponse",
  () => [
    { no: 1, name: "config", kind: "message", T: StoreShippingConfig },
  ],
);

/**
 * Shipping Rate Messages
 *
 * @generated from message fingertip.creator.store_shipping.v1.CreateShippingRateRequest
 */
export const CreateShippingRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.CreateShippingRateRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shipping_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tax_rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "tax_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "tax_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "type", kind: "enum", T: proto3.getEnumType(StoreShippingRateType) },
    { no: 10, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "google_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "pickup_instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.CreateShippingRateResponse
 */
export const CreateShippingRateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.CreateShippingRateResponse",
  () => [
    { no: 1, name: "shipping_rate", kind: "message", T: StoreShippingRate },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.UpdateShippingRateRequest
 */
export const UpdateShippingRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.UpdateShippingRateRequest",
  () => [
    { no: 1, name: "shipping_rate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shipping_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tax_rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "tax_code", kind: "message", T: StringValue },
    { no: 8, name: "tax_class", kind: "message", T: StringValue },
    { no: 9, name: "type", kind: "enum", T: proto3.getEnumType(StoreShippingRateType) },
    { no: 10, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "google_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "pickup_instructions", kind: "message", T: StringValue },
    { no: 14, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.UpdateShippingRateResponse
 */
export const UpdateShippingRateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.UpdateShippingRateResponse",
  () => [
    { no: 1, name: "shipping_rate", kind: "message", T: StoreShippingRate },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.DeleteShippingRateRequest
 */
export const DeleteShippingRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.DeleteShippingRateRequest",
  () => [
    { no: 2, name: "shipping_rate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.DeleteShippingRateResponse
 */
export const DeleteShippingRateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.DeleteShippingRateResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingRateRequest
 */
export const GetShippingRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingRateRequest",
  () => [
    { no: 2, name: "shipping_rate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingRateResponse
 */
export const GetShippingRateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingRateResponse",
  () => [
    { no: 1, name: "shipping_rate", kind: "message", T: StoreShippingRate },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingRatesItem
 */
export const GetShippingRatesItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingRatesItem",
  () => [
    { no: 1, name: "shipping_rate", kind: "message", T: StoreShippingRate },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingRatesRequest
 */
export const GetShippingRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingRatesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetShippingRatesResponse
 */
export const GetShippingRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetShippingRatesResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetShippingRatesItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * Public Cart-related Messages
 *
 * @generated from message fingertip.creator.store_shipping.v1.GetAvailableShippingRatesRequest
 */
export const GetAvailableShippingRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetAvailableShippingRatesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetAvailableShippingRatesResponse
 */
export const GetAvailableShippingRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetAvailableShippingRatesResponse",
  () => [
    { no: 1, name: "available_rates", kind: "message", T: StoreShippingRate, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetPublicShippingRatesRequest
 */
export const GetPublicShippingRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetPublicShippingRatesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.GetPublicShippingRatesResponse
 */
export const GetPublicShippingRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.GetPublicShippingRatesResponse",
  () => [
    { no: 1, name: "accepted_countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "shipping_rates", kind: "message", T: StoreShippingRate, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.ValidateShippingRateRequest
 */
export const ValidateShippingRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.ValidateShippingRateRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shipping_rate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_shipping.v1.ValidateShippingRateResponse
 */
export const ValidateShippingRateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_shipping.v1.ValidateShippingRateResponse",
  () => [
    { no: 1, name: "valid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

